import React from "react";
import CardSlide from "../Slider/card_slide";

export const SlideData = [
  {
    id: 1,
    name: "Baseline shorts",
    cate: "34,000 MMK",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP03919.jpg?alt=media&token=69e7de87-ad90-47af-bdb8-68d43d93a2ff",
  },
  {
    id: 2,
    name: "Halter Bra",
    cate: "34,000 MMK",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP03536.jpg?alt=media&token=33ab8155-fdca-4a32-a2a1-caa2263c60f3",
  },
  {
    id: 3,
    name: "Ace Sports Bra",
    cate: " 34,000 MMK",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP01351.jpg?alt=media&token=8c2672bc-8621-45f8-b689-dbbf66d06aba",
  },
  {
    id: 4,
    name: "Flow Running Short",
    cate: "34,000 MMK",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP00956.jpg?alt=media&token=72e8d8f1-c039-441a-8343-b42cc032a2e0",
  },
  {
    id: 5,
    name: "Dynamic Shorts",
    cate: "29,500 MMK",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP01327.jpg?alt=media&token=08fcfc23-e407-40eb-bc13-8f9ffdbde0c5",
  },
  {
    id: 6,
    name: "Bliss legging",
    cate: "39,500 MMK",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP01028.jpg?alt=media&token=cd63e31d-6c4f-4898-ba54-5170ffc8a36a",
  },
];
const Trending = ({title,subTitle}) => {
  return (
    <div>
      <div className="text-center mb-2 mt-10">
                 <h2 className="uppercase text-[13px] ">{title}</h2>
                 <h1 className="uppercase text-[22px]">{subTitle}</h1>
            </div>
      <CardSlide SlideData={SlideData} /> 
           <div className="text-center mt-10"><button className="bg-primary text-white  text-sm uppercase px-6 py-2 ">Shop now</button></div>
           <hr className="mt-10" />
    </div>
  );
};

export default Trending;
